import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { appRoutes } from './app';
import { authRoutes } from './auth';
import { adminRoutes } from './admin';
import { dashboardRoutes } from './dashboard';
import { activitiesRoutes } from './activities';

const OnboardingPage = lazy(() => import('src/pages/onboarding'));

export const routesSection: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={null}>
        <OnboardingPage />
      </Suspense>
    ),
  },
  ...authRoutes,
  ...adminRoutes,
  ...dashboardRoutes,
  ...appRoutes,
  ...activitiesRoutes,
];
